module.exports = __webpack_public_path__ + "static/media/Kellee-Martins-Resume.2c706b0a.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/Kellee-Martins-Resume.pdf
// module id = 21
// module chunks = 0